/*
 * Vallenzi cart drawer extras: rewards bar + smart upsells (manual / collection / Shopify recommendations)
 * Built by Claude for the CLAUDE theme — Oct 2026. Configured in the theme editor (Cart drawer section).
 */
(function () {
  if (window.__svCartLoaded) return;
  window.__svCartLoaded = true;

  function formatMoney(cents, format) {
    var fmt = format || '£{{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function delim(n, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = typeof decimal === 'undefined' ? '.' : decimal;
      var parts = (n / 100).toFixed(precision).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) + (parts[1] ? decimal + parts[1] : '');
    }
    var m = fmt.match(placeholder);
    var v;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': v = delim(cents, 0); break;
      case 'amount_with_comma_separator': v = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = delim(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = delim(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': v = delim(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': v = delim(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': v = delim(cents, 2, ' ', '.'); break;
      default: v = delim(cents, 2);
    }
    return fmt.replace(placeholder, v);
  }

  function fill(t, tokens) {
    return (t || '').replace(/\[(\w+)\]/g, function (all, k) {
      return Object.prototype.hasOwnProperty.call(tokens, k) ? tokens[k] : all;
    });
  }

  function rate() {
    return (window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate)) || 1;
  }

  /* ---------------- Rewards bar ---------------- */
  class SvRewards extends HTMLElement {
    connectedCallback() {
      var el = this.querySelector('script[data-sv-rewards]');
      if (!el) return;
      var d;
      try { d = JSON.parse(el.textContent); } catch (e) { return; }
      var steps = d.steps.filter(function (s) { return s.threshold > 0; });
      if (!steps.length) { this.hidden = true; return; }
      var byAmount = d.basis === 'amount';
      var value = byAmount ? d.total : d.count;
      var thresholds = steps.map(function (s) { return byAmount ? Math.round(s.threshold * 100 * rate()) : s.threshold; });
      var n = steps.length;
      var reachedIndex = -1;
      thresholds.forEach(function (t, i) { if (value >= t) reachedIndex = i; });
      var next = reachedIndex + 1 < n ? reachedIndex + 1 : -1;

      var progress;
      var edges = this.dataset.layout === 'edges' && n > 1;
      if (next === -1) progress = 1;
      else if (edges) {
        // markers sit at 0%, ..., 100%: fill reaches marker i when step i is unlocked
        if (next === 0) progress = 0;
        else {
          var e0 = thresholds[next - 1];
          var e1 = thresholds[next];
          var seg = e1 > e0 ? (value - e0) / (e1 - e0) : 0;
          progress = (next - 1 + Math.max(0, Math.min(1, seg))) / (n - 1);
        }
      } else {
        var p0 = next === 0 ? 0 : thresholds[next - 1];
        var p1 = thresholds[next];
        var segment = p1 > p0 ? (value - p0) / (p1 - p0) : 0;
        progress = (next + Math.max(0, Math.min(1, segment))) / n;
      }
      var fillEl = this.querySelector('[data-sv-fill]');
      if (fillEl) fillEl.style.width = (progress * 100).toFixed(2) + '%';
      this.querySelectorAll('[data-sv-step]').forEach(function (s, i) {
        s.classList.toggle('is-reached', i <= reachedIndex);
      });

      var msg;
      var B = '\u0001', E = '\u0002';
      if (next === -1) {
        msg = fill(d.all_text, { reward: steps[n - 1].label });
      } else {
        var remaining = thresholds[next] - value;
        var remainingText = byAmount ? formatMoney(remaining, d.money_format) : String(remaining);
        var items = remaining === 1 ? d.item_singular : d.item_plural;
        msg = fill(d.progress_text, { remaining: B + remainingText + E, items: byAmount ? '' : B + items + E, reward: B + steps[next].label + E, count: String(value) })
          .replace(/\s{2,}/g, ' ');
        if (reachedIndex >= 0 && d.unlocked_text) {
          msg = fill(d.unlocked_text, { reward: steps[reachedIndex].label }) + ' ' + msg;
        }
      }
      var msgEl = this.querySelector('[data-sv-msg]');
      if (msgEl) {
        var safe = msg.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        msgEl.innerHTML = safe.split(B).join('<strong>').split(E).join('</strong>').replace(/<\/strong>(\s*)<strong>/g, '$1');
      }
      if (!this.hasAttribute('data-sv-ghost')) this.hidden = false;
      this.sync(steps, reachedIndex, d);
    }

    /* Keeps gifts and discount codes in line with the goals reached. One change per render. */
    sync(steps, reachedIndex, d) {
      var g = window.__svRewardsGuard || (window.__svRewardsGuard = { n: 0, t: Date.now(), busy: false });
      if (Date.now() - g.t > 60000) { g.n = 0; g.t = Date.now(); }
      if (g.busy || g.n >= 8) return;
      var reached = {};
      steps.forEach(function (s, i) { if (i <= reachedIndex) reached[s.id] = s; });
      var lines = (d.gift_lines || '').split(',').filter(Boolean).map(function (l) {
        var p = l.split('|'); return { step: p[0], key: p[1] };
      });
      var post = function (url, body) {
        g.busy = true; g.n++;
        var drawer = document.querySelector('cart-drawer');
        var sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
        if (sections.length) { body.sections = sections.join(','); body.sections_url = window.location.pathname; }
        return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
          .then(function (r) { return r.json(); })
          .then(function (json) { g.busy = false; if (!json.status) refreshDrawer(json); })
          .catch(function () { g.busy = false; });
      };
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      // 1. remove gifts whose goal is no longer reached
      for (var i = 0; i < lines.length; i++) {
        if (!reached[lines[i].step]) { post(root + 'cart/change.js', { id: lines[i].key, quantity: 0 }); return; }
      }
      // 2. add automatic gifts for reached goals
      for (var j = 0; j < steps.length; j++) {
        var s = steps[j];
        if (reached[s.id] && s.type === 'gift' && s.gift_variant) {
          var has = lines.some(function (l) { return l.step === s.id; });
          if (!has) { post(root + 'cart/add.js', { items: [{ id: parseInt(s.gift_variant, 10), quantity: 1, properties: { _sv_gift: s.id } }] }); return; }
        }
      }
      // 3. discount codes linked to goals
      var codeSteps = steps.filter(function (s) { return s.code; });
      if (!codeSteps.length) return;
      g.busy = true;
      fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        g.busy = false;
        var current = (cart.discount_codes || []).map(function (c) { return c.code; });
        var lower = current.map(function (c) { return c.toLowerCase(); });
        var want = current.slice();
        var changed = false;
        codeSteps.forEach(function (s) {
          var idx = lower.indexOf(s.code.toLowerCase());
          if (reached[s.id] && idx === -1) { want.push(s.code); changed = true; }
          if (!reached[s.id] && idx !== -1) { want = want.filter(function (c) { return c.toLowerCase() !== s.code.toLowerCase(); }); changed = true; }
        });
        if (changed) post(root + 'cart/update.js', { discount: want.join(',') });
      }).catch(function () { g.busy = false; });
    }
  }
  if (!customElements.get('sv-rewards')) customElements.define('sv-rewards', SvRewards);

  /* ---------------- Upsells ---------------- */
  var recCache = {};

  class SvUpsells extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-sv-upsell-track]');
      this.applyLabels();
      this.limit();
      if (this.dataset.source === 'recommended' && this.dataset.productId) this.loadRecommendations();
      else this.finish();
    }

    applyLabels() {
      var label = this.dataset.btn;
      if (!label) return;
      this.querySelectorAll('[data-sv-upsell-add]').forEach(function (b) { b.textContent = label; });
    }

    limit() {
      var max = parseInt(this.dataset.max, 10) || 6;
      var hideInCart = this.dataset.hideInCart === 'true';
      var inCart = '-' + (this.dataset.cartKey || '');
      var cards = this.track ? this.track.querySelectorAll('[data-sv-upsell]') : [];
      var shown = 0;
      var seen = {};
      Array.prototype.forEach.call(cards, function (c) {
        var pid = c.getAttribute('data-product-id') || '';
        var skip = (pid && hideInCart && inCart.indexOf('-' + pid + '-') !== -1) || (pid && seen[pid]);
        if (pid) seen[pid] = true;
        c.hidden = skip || shown >= max;
        if (!c.hidden) shown++;
      });
    }

    finish() {
      var visible = this.track && this.track.querySelector('[data-sv-upsell]:not([hidden])');
      this.hidden = !visible;
      this.setupNav();
    }

    setupNav() {
      var self = this;
      var t = this.track;
      if (!t) return;
      var btns = this.querySelectorAll('[data-sv-dir]');
      if (!btns.length) return;
      if (!this._nav) {
        this._nav = true;
        btns.forEach(function (b) {
          b.addEventListener('click', function (e) {
            e.preventDefault();
            var c = t.querySelector('[data-sv-upsell]:not([hidden])');
            var st = getComputedStyle(t);
            var gap = parseFloat(st.columnGap || st.gap) || 0;
            var w = c ? c.getBoundingClientRect().width + gap : t.clientWidth * 0.8;
            t.scrollBy({ left: w * parseInt(b.getAttribute('data-sv-dir'), 10), behavior: 'smooth' });
          });
        });
        t.addEventListener('scroll', function () { self.navState(); }, { passive: true });
        if (window.ResizeObserver) new ResizeObserver(function () { self.navState(); }).observe(t);
      }
      requestAnimationFrame(function () { self.navState(); });
    }

    navState() {
      var t = this.track;
      if (!t) return;
      var max = t.scrollWidth - t.clientWidth - 2;
      var over = max > 0;
      this.classList.toggle('sv-upsells--overflow', over);
      this.querySelectorAll('[data-sv-dir]').forEach(function (b) {
        var d = parseInt(b.getAttribute('data-sv-dir'), 10);
        b.disabled = !over || (d < 0 ? t.scrollLeft <= 2 : t.scrollLeft >= max);
      });
    }

    loadRecommendations() {
      var self = this;
      var key = this.dataset.productId + '|' + this.dataset.intent + '|' + this.dataset.max + '|' + (this.dataset.cartKey || '');
      var render = function (html) {
        if (!html) { self.finish(); return; }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = doc.querySelectorAll('[data-sv-upsell]');
        if (!cards.length) { self.finish(); return; }
        var frag = document.createDocumentFragment();
        cards.forEach(function (c) { frag.appendChild(document.importNode(c, true)); });
        self.track.innerHTML = '';
        self.track.appendChild(frag);
        self.applyLabels();
        self.limit();
        self.finish();
      };
      if (recCache[key] !== undefined) { render(recCache[key]); return; }
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var url = root + 'recommendations/products?section_id=sv-cart-recommendations&product_id=' +
        encodeURIComponent(this.dataset.productId) + '&limit=' + (parseInt(this.dataset.max, 10) + 4) + '&intent=' + (this.dataset.intent || 'related');
      fetch(url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var hasCards = html && html.indexOf('data-sv-upsell') !== -1;
          recCache[key] = hasCards ? html : '';
          if (hasCards) { render(html); return; }
          // No recommendations for this product: try the next paid product in the cart
          var ids = (self.dataset.productIds || '').split(',').filter(Boolean);
          var pos = ids.indexOf(String(self.dataset.productId));
          if (pos !== -1 && pos + 1 < ids.length) { self.dataset.productId = ids[pos + 1]; self.loadRecommendations(); return; }
          self.finish();
        })
        .catch(function () { self.finish(); });
    }
  }
  if (!customElements.get('sv-upsells')) customElements.define('sv-upsells', SvUpsells);

  /* ---------------- shared add to cart ---------------- */
  function refreshDrawer(json, btn) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && json.sections && typeof drawer.renderContents === 'function') {
      var first = json.items && json.items[0];
      try {
        drawer.renderContents({ id: first ? first.id : null, sections: json.sections });
        if (typeof json.item_count === 'number') drawer.classList.toggle('is-empty', json.item_count === 0);
        return;
      } catch (e) {}
    }
    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  }

  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('select[data-sv-upsell-variant]');
    if (!sel) return;
    var card = sel.closest('[data-sv-upsell]');
    var opt = sel.options[sel.selectedIndex];
    var btn = card && card.querySelector('[data-sv-upsell-add]');
    if (btn) btn.dataset.variant = sel.value;
    var price = card && card.querySelector('[data-sv-upsell-price]');
    if (price && opt && opt.dataset.price) price.textContent = opt.dataset.price;
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-sv-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-disabled') === 'true') return;
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('is-loading');
    var drawer = document.querySelector('cart-drawer');
    var sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
    var props = btn.dataset.svGift ? { _sv_gift: btn.dataset.svGift } : { _sv_upsell: '1' };
    var body = { items: [{ id: parseInt(btn.dataset.variant, 10), quantity: 1, properties: props }] };
    if (sections.length) {
      body.sections = sections.join(',');
      body.sections_url = window.location.pathname;
    }
    fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (json.status) {
          var card = btn.closest('[data-sv-upsell]');
          var err = card && card.querySelector('[data-sv-upsell-error]');
          if (err) { err.textContent = json.description || json.message || ''; err.hidden = false; }
          return;
        }
        refreshDrawer(json, btn);
      })
      .catch(function () {})
      .finally(function () {
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('is-loading');
      });
  });

  /* ---------------- Gift guard ----------------
     Gifts = lines with the _sv_gift (rewards) or _sv_bundle_gift (bundle) property.
     - Bundle gifts are removed when the bundle product they came with is no longer in the cart.
     - All gifts are removed when there is no paid product left in the cart. */
  var svGiftBusy = false, svGiftLast = '', svGiftTimer = null;
  function svIsGift(it) { var p = it.properties || {}; return !!(p._sv_gift || p._sv_bundle_gift); }
  function svIsPaid(it) { return !svIsGift(it) && !/shipping protection/i.test((it.product_type || '') + ' ' + (it.product_title || '')); }
  function svGiftCheck() {
    if (svGiftBusy) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    svGiftBusy = true;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var sig = (cart.items || []).map(function (i) { return i.key + ':' + i.quantity; }).join('|');
      if (sig === svGiftLast) { svGiftBusy = false; return; }
      svGiftLast = sig;
      var items = cart.items || [];
      var paid = items.filter(svIsPaid);
      var labels = {};
      paid.forEach(function (i) { var b = (i.properties || {})._sv_bundle; if (b) labels[b] = true; });
      var updates = {}, n = 0;
      items.forEach(function (i) {
        if (!svIsGift(i)) return;
        var p = i.properties || {};
        if (!paid.length || (p._sv_bundle_gift && !labels[p._sv_bundle_gift])) { updates[i.key] = 0; n++; }
      });
      if (!n) { svGiftBusy = false; return; }
      var body = { updates: updates };
      var drawer = document.querySelector('cart-drawer');
      var sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
      if (sections.length) { body.sections = sections.join(','); body.sections_url = window.location.pathname; }
      return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          svGiftBusy = false; svGiftLast = '';
          if (/\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return; }
          if (drawer && json.sections && typeof drawer.renderContents === 'function') { try { drawer.renderContents({ id: null, sections: json.sections }); } catch (e) {} }
          if (drawer && typeof json.item_count === 'number') drawer.classList.toggle('is-empty', json.item_count === 0);
          document.querySelectorAll('.cart-count-bubble span[aria-hidden], [data-cart-count]').forEach(function () {});
        });
    }).catch(function () { svGiftBusy = false; });
  }
  function svGiftSoon() { clearTimeout(svGiftTimer); svGiftTimer = setTimeout(svGiftCheck, 500); }
  document.addEventListener('DOMContentLoaded', svGiftSoon);
  if (document.readyState !== 'loading') svGiftSoon();
  (function watch() {
    var targets = document.querySelectorAll('cart-drawer, #main-cart-items, cart-items');
    if (!targets.length) { setTimeout(watch, 800); return; }
    var mo = new MutationObserver(svGiftSoon);
    targets.forEach(function (t) { mo.observe(t, { childList: true, subtree: true }); });
  })();
})();

document.addEventListener('click', function (e) {
  var dot = e.target.closest && e.target.closest('[data-sv-upsell-dot]');
  if (!dot || dot.disabled) return;
  e.preventDefault();
  var card = dot.closest('[data-sv-upsell]');
  if (!card) return;
  var sel = card.querySelector('select[data-sv-upsell-variant]');
  if (sel) { sel.value = dot.dataset.variant; sel.dispatchEvent(new Event('change', { bubbles: true })); }
  card.querySelectorAll('[data-sv-upsell-dot]').forEach(function (b) { var on = b === dot; b.classList.toggle('is-active', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
});
